import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Grid, Table, TableCell, TableHead, TableRow, TableBody, Typography, useTheme, CircularProgress, Paper } from '@material-ui/core';
import { ImcGenericStyle } from '../../ImcGeneric/ImcGenericStyle';
import MigaPan from '../../../../app/orussystem/component/MigaPan';//../../../app/orussystem/component/MigaPan
import { FaMapLocationDot, FaChampagneGlasses } from "react-icons/fa6";
import AlcFilter from './alcFilter';
import clsx from 'clsx';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import { MdCalendarMonth } from "react-icons/md";
import AcTotales from '../../Alcolimetria/alcTotales';
import '../../GeneriBascula.js/graficas.css'
import { panelUsersAuthStyle } from '../../../users_auth/panelUsersAuthStyle';
import GraficaAlcohol from '../../Alcolimetria/GraficaAlcohol';

//IMPORTS DE RegistroAlcohol
import { getHistoricoDocumento } from '../../../domain/api/UsersApi';


export const RegistroAlcohol = (props) => {

  const classes = ImcGenericStyle();
  const [dataEnd, setDataEnd] = useState(UtilsDate().formatYYYYMMdd(new Date()));
  const [isLoading] = useState(false);
  const [, location] = useLocation();

  let { id } = useParams();

  const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 7 : id;

  const [dataPositivo, setDataPositivo] = useState([]);
  const [dataNegativo, setDataNegativo] = useState([]);
  const [dataTotal, setDataTotal] = useState([]);

  const clases = panelUsersAuthStyle()

  const fixedHeightFilter = clsx(classes.paper, classes.fixedHeightFilter);
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [imcTotalGrafic] = useState([]);

  //fecha inicial
  const originalDateIni = new Date();
  const yearIni = originalDateIni.getFullYear();
  const monthIni = originalDateIni.getMonth();
  const dayIni = originalDateIni.getDate();
  const dateIni = `${yearIni}-${monthIni.toString().padStart(2, '0')}-${dayIni.toString().padStart(2, '0')}`;
  const [dataStart, setDataStart] = useState(dateIni);

  const [UsersMachine, setUsersMachine] = useState([]);
  const [MensajeError, setMensajeError] = useState(null);
  const [iSLoaduser, setISloaduser] = useState(false);
  const [busquedaUsuario, setBusquedaUsuario] = useState("")
  const [nombreUsuario, setNombreUsuario] = useState("")
  const [mediciones, setMediciones] = useState([]);
  const [documento, setDocumento] = useState("");
  const [, setFechaMedicion] = useState("");
  const [celular, setCelular] = useState("");
  const [genero, setGenero] = useState("N/A");
  const [edad, setEdad] = useState("N/A");
  const [email, setEmail] = useState("N/A");
  const [area, setArea] = useState("N/A");


  // SETEAR FECHAS A FILTRO
  const handlerFilter = (dataStart, dataEnd) => {
    setDataEnd(UtilsDate().formatYYYYMMdd(dataEnd));
    setDataStart(UtilsDate().formatYYYYMMdd(dataStart))
    busqueda(UtilsDate().formatYYYYMMdd(dataStart), UtilsDate().formatYYYYMMdd(dataEnd))
  };
  const busqueda = (dataStart, dataEnd) => {
    reload(busquedaUsuario, dataStart, dataEnd)
    setISloaduser(true)
  }

  const theme = useTheme(); // Obtén el tema
  const primaryColor = theme.palette.primary.main;

  //BUSCAR USUARIO
  const reload = async (busquedaUsuario, dataStartParam = "", dataEndParam = "") => {
    const usuarios = await getHistoricoDocumento(busquedaUsuario, dataStartParam, dataEndParam);
    try {
      setUsersMachine(usuarios?.respuesta ? usuarios.respuesta : [])
      setNombreUsuario(usuarios?.respuesta ? usuarios.respuesta.user.firstname : "")
      setCelular(usuarios?.respuesta ? usuarios.respuesta.user.celular : "")
      setDocumento(usuarios?.respuesta ? usuarios.respuesta.user.numerodocumento : "");
      setGenero(usuarios?.respuesta ? usuarios.respuesta.user.genero ?? "N/A" : "N/A");

      const calcularEdad = fecha => fecha ? new Date().getFullYear() - new Date(fecha).getFullYear() - (new Date() < new Date(new Date().getFullYear(), new Date(fecha).getMonth(), new Date(fecha).getDate()) ? 1 : 0) : "N/A";
      const fechaNacimiento = usuarios?.respuesta?.user?.edad;
      setEdad(calcularEdad(fechaNacimiento));
      setEmail(usuarios?.respuesta?.user?.email || "N/A");
      setArea(usuarios?.respuesta?.user?.area || "N/A");

      const negativo = (usuarios?.respuesta?.totales?.negativos ?? 0);
      const positivo = (usuarios?.respuesta?.totales?.positivos ?? 0);
      const total = (usuarios?.respuesta?.totales?.total ?? 0);
      const medicionesPositivas = Array.isArray(usuarios?.respuesta?.medicionesPositivas)
        ? usuarios?.respuesta.medicionesPositivas
        : [];

      const mediciones = medicionesPositivas.filter((m) => m.grado_Alcohol > 0);

      setDataNegativo(negativo)
      setDataPositivo(positivo)
      setDataTotal(total)
      setMediciones(mediciones);

      if (usuarios?.mensaje === "No existe un usuario con ese documento") {
        setMensajeError(usuarios.mensaje);
        setISloaduser(false)
      } else {
        setMensajeError(null); // Limpiar mensaje de error si no es el caso
        setISloaduser(false)
      }
    } catch (err) {
      console.log("Este es el error", err)
    }
  }

  const filtrar = () => {
    reload(busquedaUsuario);
    setISloaduser(true)
  };

  const buscador = (e) => {
    setBusquedaUsuario(e.target.value, "esta es la busqueda")
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      filtrar();
    }
  };

  

  return (
    <>
      <Grid item xs={12} >
        <br></br>
        <br></br>
        <MigaPan
          namePage="Registro de alcoholimetria"
          to="/"
          namePage2="Datos"
          to2="/Datos"
        >
          Home
        </MigaPan>
      </Grid>

      <Paper className={classes.paper} style={{ width: "100%", borderRadius: "15px" }} >
        <Grid item xs={12}>
          <Grid container >
            <Grid container justifyContent="center" alignItems="center" spacing={2} style={{ marginBottom: 16 }}>
              <Grid item style={{ marginRight: '2%', marginLeft: '2%' }}>
                <div style={{ marginRight: '2%', display: 'flex', alignItems: 'center', padding: 0, width: '100%', height: '100%' }}>
                  <input
                    id="descripcion"
                    name="descripcion"
                    onChange={buscador}
                    value={busquedaUsuario}
                    onKeyPress={handleKeyPress}
                    placeholder="Buscar por documento"
                    style={{
                      border: `1px solid ${theme.palette.primary.main}`,
                      borderRadius: '20px',
                      padding: '6px 12px',
                      fontSize: '14px',
                      outline: 'none',
                      width: '170px',
                    }}
                  />
                </div>
              </Grid>

              {/* Fechas */}
              <Grid item>
                <AlcFilter
                  handlerFilter={handlerFilter}
                  isLoading={isLoading}
                  isDate={false}
                  idBascula={idBascula}
                  total={dataTotal}
                  nameUsuario={nombreUsuario}
                  dataStartParam={dataStart}
                  dataEndParam={dataEnd}
                />
              </Grid>
            </Grid>

            {iSLoaduser ? (

              <CircularProgress style={{ marginLeft: '50%' }} />

            ) : UsersMachine.length !== 0 ? (
              <>

              </>
            ) : MensajeError ? (
              <Grid item xs={12}>
                <Paper className={classes.card}>
                  <Typography variant="body1" style={{ padding: '1%', textAlign: 'center' }}>No se encuentran resultados para este documento, es necesario pasar por una estación de medición para registrarse</Typography>
                </Paper>
              </Grid>
            ) : null}
          </Grid>
        </Grid>

        {MensajeError === null && iSLoaduser === false && UsersMachine.length === 0 && (
          <Grid item xs={12}>
            <Typography variant="body1" style={{ padding: '1%', textAlign: 'center' }}>Ingresa el documento del usuario para buscarlo en el sistema</Typography>
          </Grid>
        )}
      </Paper>
      {!iSLoaduser && UsersMachine.length !== 0 && (
        <>
          <Grid item xs={12}>
            <Paper className={fixedHeightFilter} style={{ overflow: 'hidden', height: '100%', padding: '24px' }}>
              <Typography align="center" style={{ fontWeight: 'bold', fontSize: "26px", marginBottom: '20px' }} color='primary'>
                Datos del Usuario {nombreUsuario ? `${nombreUsuario}` : ""}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={2}></Grid>
                <Grid item xs={4}>
                  <Typography style={{ marginBottom: '8px' }}><strong>Documento:</strong> {documento || "N/A"}</Typography>
                  <Typography style={{ marginBottom: '8px' }}><strong>Correo:</strong> {email || "N/A"}</Typography>
                  <Typography style={{ marginBottom: '8px' }}><strong>Género:</strong> {genero === "F" ? "Femenino" : genero === "M" ? "Masculino" : "N/A"}</Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={4}>

                  <Typography style={{ marginBottom: '8px' }}><strong>Área:</strong> {area || "N/A"}</Typography>
                  <Typography style={{ marginBottom: '8px' }}><strong>Celular:</strong> {celular || "N/A"}</Typography>
                  <Typography style={{ marginBottom: '8px' }}><strong>Edad:</strong> {edad > 0 ? `${edad} años` : "N/A"}</Typography>
                </Grid>
                <Grid item xs={2}></Grid>
              </Grid>
            </Paper>
          </Grid>




          <Grid item xs={9} >
            <Paper style={{ borderRadius: '20px', height: '105%', width: '100%' }}>
              <GraficaAlcohol
                negativos={dataNegativo}
                positivos={dataPositivo}
                total={dataTotal}
                totalPositivos={'Total de mediciones'}
              >
              </GraficaAlcohol>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper className={fixedHeightPaper}>
              <AcTotales data={imcTotalGrafic}
                totalPositivos={`Total positivos`}
                positivo={dataPositivo} />
            </Paper>
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <Paper className={fixedHeightPaper}>
              <Typography align="center" style={{ fontWeight: 'bold', fontSize: "26px" }} color='primary' >
                Registros Positivos
              </Typography>
              <Grid item xs={12}>
                <Table>
                  <TableHead style={{ color: '#0088FE' }}>
                    <TableRow style={{ color: '#0088FE' }}>
                      <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}><FaMapLocationDot style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Ubicación</TableCell>
                      <TableCell className={clases.TableCell} style={{ paddingLeft: '8%', width: '20%', color: primaryColor }}><FaChampagneGlasses style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Grados de Alcohol</TableCell>
                      <TableCell className={clases.TableCell} style={{ width: '25%', paddingLeft: '7%', color: primaryColor }}><MdCalendarMonth style={{ marginBottom: '-2%', marginRight: '3%', fontSize: '22px' }} />Fecha y Hora de Registro</TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </Grid>
              <Grid item xs={12}>
                <TableBody>
                  {mediciones.map((medicion, index) => (
                    <TableRow key={index}>
                      <TableCell className={clases.TableCell2} item style={{ width: '10%', paddingLeft: '5%' }}>{medicion.ubicacion ?? 'N/A'}</TableCell>
                      <TableCell className={clases.TableCell2} item style={{ width: '10%', paddingLeft: '12.5%' }}>{medicion.grado_Alcohol}</TableCell>
                      <TableCell className={clases.TableCell2} item style={{ width: '10%', paddingLeft: '8%' }}>{medicion.datecreated ? new Date(medicion.datecreated).toLocaleDateString('es-ES', { day: 'numeric', month: 'numeric', year: 'numeric' }) + ' ' + new Date(medicion.datecreated).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) : '--'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Grid>
            </Paper>
          </Grid>
        </>
      )}
    </>
  );
}

